import React, { useEffect, useState } from "react";
import { humanFileSize } from "../../Utils/functions";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
const ImageUploader = ({
  element,
  form,
  setForm,
  edit = false,
  single = true,
}) => {
  const onSelectFile = e => {
    if (!e.target.files || e.target.files.length === 0) {
      setForm({ ...form, [element.key]: undefined });
    }
    if (single) {
      setForm({ ...form, [element.key]: e.target.files[0] });
    } else {
      if (form[element.key]) {
        if (typeof form[element.key] == "object") {
          setForm({
            ...form,
            [element.key]: [...form[element.key], ...e.target.files],
          });
        } else {
          setForm({
            ...form,
            [element.key]: e.target.files,
          });
        }
      } else {
        setForm({ ...form, [element.key]: e.target.files });
      }
    }
  };
  const renderMulti = () => {
    if (form[element.key]) {
      if (
        typeof form[element.key] == "object" &&
        !Array.isArray(form[element.key])
      ) {
        return Array.from(form[element.key])
          .filter(Boolean)
          .map((img, count) => {
            return (
              <div className="position-relative">
                <img src={URL.createObjectURL(img)} />
                {console.log("1:", element.key)}
                <button
                  className="btn btn-outline-danger p-1 py-0"
                  style={{ position: "absolute", top: 0, right: 0 }}
                  onClick={() => {
                    setForm({
                      ...form,
                      [element.key]: [
                        ...[...form[element.key]]
                          .filter(imgF => imgF.name != img.name)
                          .filter(Boolean),
                      ],
                    });
                  }}
                >
                  <AiOutlineClose />
                </button>
              </div>
            );
          });
      } else {
        return form[element.key].map(img => {
          return (
            <div className="position-relative">
              <img src={img.url || URL.createObjectURL(img)} width="110" height="110" />
              <button
                className="btn btn-outline-danger p-1 py-0"
                style={{ position: "absolute", top: 0, right: 0 }}
                onClick={() => {
                  setForm({
                    ...form,
                    [element.key]: [
                      ...[...form[element.key]]
                        .filter(imgF => imgF.name != img.name)
                        .filter(Boolean),
                    ],
                  });
                }}
              >
                <AiOutlineClose />
              </button>
            </div>
          );
        });
      }
    } else {
      return <></>;
    }
  };
  const render = () => {
    if (single) {
      return (
        <div>
          <div className="add mb-2">
            <input
              id="fileUploader"
              type={"file"}
              className="d-none"
              accept="image/*"
              multiple
              onChange={onSelectFile}
            />
            <label
              className="dz-message d-block  w-100"
              htmlFor="fileUploader"
              style={{ cursor: "pointer" }}
            >
              <>
                <div className="d-flex justify-content-center">
                  <AiOutlinePlus size={"2rem"} />
                </div>
              </>
            </label>
          </div>
          <div>
            {form[element.key] &&
              (form[element.key].url ? (
                <>
                  <img
                    className="dz-image"
                    alt="29.png"
                    data-dz-thumbnail="data-dz-thumbnail"
                    src={form[element.key].url}
                    style={{
                      borderRadius: "15px",
                      width: "100px",
                      height: "100px",
                      objectFit: "contain",
                    }}
                  />
                </>
              ) : (
                <img
                  className="dz-image"
                  alt="29.png"
                  data-dz-thumbnail="data-dz-thumbnail"
                  src={
                    form[element.key] && URL.createObjectURL(form[element.key])
                  }
                  style={{
                    borderRadius: "15px",
                    width: "20%",
                    height: "130px",
                    objectFit: "contain",
                  }}
                />
              ))}
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div className="add">
            <input
              id="multiUplpader"
              type={"file"}
              className="d-none"
              accept="image/*"
              multiple
              onChange={onSelectFile}
            />
            <label
              className="dz-message d-block  w-100"
              htmlFor="multiUplpader"
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex justify-content-center">
                <AiOutlinePlus size={"2rem"} />
              </div>
            </label>
          </div>
          <div className="images">{renderMulti()}</div>
        </>
      );
    }
  };
  return (
    <div className="image-uploader-wrapper  ">
      <div>
        <div>
          <label>{element.label}</label>
        </div>
        <smal className="fs-10">{element.subLabel}</smal>
      </div>
      {render()}
    </div>
  );
};

export default ImageUploader;
